import React from 'react';

import BlockSkeleton from '../../../../components/Skeleton/BlockSkeleton';
import TextSkeleton from '../../../../components/Skeleton/TextSkeleton';

import Classes from './AdmarktSimilarItems.scss';

const ITEMS_COUNT = 6;
const ITEMS_COUNT_EXPERIMENT_FEED = 12;
const AdmarktSimilarItemsListSkeleton = ({ isExperimentFeedEnabled }: { isExperimentFeedEnabled?: boolean }) => {
  return (
    <div className={`${Classes.list} ${isExperimentFeedEnabled ? Classes.experimentEnabled : ''}`}>
      {Array(isExperimentFeedEnabled ? ITEMS_COUNT_EXPERIMENT_FEED : ITEMS_COUNT)
        .fill(true)
        .map((_, index) => (
          <div className={`hz-Card ${Classes.item}`} key={index}>
            <article className="hz-Listing hz-Listing--vertical">
              <div className="hz-Image hz-Listing-image">
                <BlockSkeleton withAnimation={true} />
              </div>
              <div className="hz-Block">
                <div className="hz-Listing-title">
                  <TextSkeleton />
                </div>
                <div className="hz-Listing-price">
                  <TextSkeleton type="short" />
                </div>
              </div>
            </article>
          </div>
        ))}
    </div>
  );
};

export default AdmarktSimilarItemsListSkeleton;
